<!-- Add "scoped" attribute to limit CSS to this component only -->
<template src="./Map.html" />
<style src="./Map.css"></style>

<script>

  import Popup from '@/components/Popup/Popup'

  import L from 'leaflet'
  import 'leaflet.markercluster' // overhide the default leaflet with features
  import 'leaflet.locatecontrol'

  /*import markerNoBikeImage from '@/assets/marker_no_bike.png'
  import markerNoStandImage from '@/assets/marker_no_stand.png'
  import markerOpenStationImage from '@/assets/marker_open.png'*/
  import markerOnlyBikeImage from '@/assets/yellow-marker.svg'
  import markerOnlyStandImage from '@/assets/grey-marker.svg'
  import markerOpenStationImage from '@/assets/green-marker.svg'
  import markerCloseStationImage from '@/assets/red-marker.svg'

  export default {
    name: 'Map',
    components: {
      Popup
    },
    props: {
      townSelected: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        map: '',
        openedStationIcon: L.Icon,
        markerOnlyBikeIcon: L.Icon,
        markerOnlyStandIcon: L.Icon,
        closedStationIcon: L.Icon,
        addedCity: []
      }
    },
    watch: {
      townSelected() {
        const areMarkersEverSet = (this.addedCity.indexOf(this.$props.townSelected) > -1)

        // only fly if markers exists, otherwise add them & fly
        if (areMarkersEverSet) {
          this.flyToNewCity(this.$props.townSelected)
        } else {
          this.updateMap(this.$props.townSelected)
        }
      }
    },
    async mounted() {
      this.setupMap(this.$props.townSelected)
    },
    methods: {
      async setupMap(city) {
        // Setup custom icons
        this.markerOnlyBikeIcon = L.icon({
          iconUrl: markerOnlyBikeImage,
          iconSize: [38, 38]
        })

        this.markerOnlyStandIcon = L.icon({
          iconUrl: markerOnlyStandImage,
          iconSize: [38, 38]
        })

        this.openedStationIcon = L.icon({
          iconUrl: markerOpenStationImage,
          iconSize: [38, 38]
        })

        this.closedStationIcon = L.icon({
          iconUrl: markerCloseStationImage,
          iconSize: [38, 38]
        })

        // Determine where to center the map
        // https://nominatim.openstreetmap.org/search?format=json&q=Lyon
        const cityPosition = await this.getCityGeo(city)

        if (!cityPosition) {
          console.error('City not found')
          return
        }
        this.map = L.map('mapid').setView([cityPosition.lat, cityPosition.lon], 13)

        // Add localization feature
        L.control.locate().addTo(this.map)

        // Create markers
        await this.addMarkers(this.map, city)
      },
      async updateMap(city) {
        await this.flyToNewCity(city)
        await this.addMarkers(this.map, this.$props.townSelected)
      },
      async addMarkers(map, city) {
        // Create the main layer
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          // List of layers https://studio.mapbox.com/tilesets/
          // List of layers https://docs.mapbox.com/api/maps/styles/#mapbox-styles
          id: 'mapbox/dark-v10',
          // id: 'mapbox/streets-v11',
          accessToken: 'pk.eyJ1Ijoia2Vpcm8iLCJhIjoiY2p1YnQ2eDlpMDRtbzQ0czBvNmVwN3Y2ZCJ9.WdBXFqXCnzBtaQ7zZlebzQ'
        }).addTo(map)

        // For clustering markers
        const markers = new L.MarkerClusterGroup()
        // fetch all station from City selected
        // get which api should be call for this city
        const mappingCity = {
          montpellier: 'opendata'
        }
        // jcdecaux by default
        const apiNameTocall = (mappingCity[city]) ? mappingCity[city] : 'jcdecaux'

        // call api fetching all station from City selected
        await ((apiNameTocall === 'jcdecaux') ? this.getDataFormatedFromJcDecaux(city) : this.getDataFormatedFromMontpellier())
          .then(jsonResult => jsonResult.forEach((station) => {
            const isStationFullyAvailable = (station.status === 'OPEN' && station.availableBikes > 0 && station.availableBikesStands > 0)
            const isOpenWithOnlyBikes = (station.status === 'OPEN' && station.availableBikes > 0 && Number(station.availableBikesStands) === 0)
            const isOpenWithOnlyStands = (station.status === 'OPEN' && Number(station.availableBikes) === 0 && station.availableBikesStands > 0)


            // Defines which mark to use
            const stationMarker = L.marker(
              [station.position.lat, station.position.lng],
              {
                title: station.name,
                // display ≠ icon whether station is open or closed
                icon: isStationFullyAvailable
                  ? this.openedStationIcon
                  : isOpenWithOnlyBikes
                    ? this.markerOnlyBikeIcon
                    : isOpenWithOnlyStands
                      ? this.markerOnlyStandIcon
                      : this.closedStationIcon
              }
            )
            stationMarker.bindPopup(this.createPopupcontent(station)).openPopup()

            markers.addLayer(stationMarker)
          }))

        map.addLayer(markers)
        // add the city to the list of creating markers
        this.addedCity.push(city)
      },
      getDataFormatedFromJcDecaux(city) {
        return fetch(`https://api.jcdecaux.com/vls/v1/stations?contract=${city}&apiKey=e5a9732090f5d7729496de52668c5781ff0740d1`)
          .then(response => response.json())
          // Format data replacing JSON property by commons to merge all external API
          .then(jsonData => {
            jsonData.forEach(property => {
              /* property.status = property.status
              property.name = property.name
              property.number = property.number
              property.address = property.address */
              property.bikeStands = property.bike_stands
              property.availableBikesStands = property.available_bike_stands
              property.availableBikes = property.available_bikes
              /* property.position.lat = property.position.lat
              property.position.lng = property.position.lng */

              delete property.bike_stands
              delete property.available_bikes
              delete property.available_bike_stands
            })
            return jsonData
          })
      },
      getDataFormatedFromMontpellier() {
        // Use the new API that provides real-time availability data
        return fetch('https://portail-api-data.montpellier3m.fr/bikestation?limit=1000')
          .then(response => {
            return response.json();
          })
          .then(jsonData => {
            // Check that the data is in the expected format
            if (!Array.isArray(jsonData)) {
              throw new Error('Unexpected data format');
            }

            // Transform API format to the common format expected by the application
            return jsonData.map(station => {
              // Extract the numeric station ID (ex: "urn:ngsi-ld:station:001" => "1")
              const stationIdMatch = station.id.match(/urn:ngsi-ld:station:0*(\d+)$/);
              const stationNumber = stationIdMatch ? stationIdMatch[1] : "";

              // Extract the station name from the address
              const stationName = station.address.value.streetAddress;

              // Determine the station status
              const status = station.status.value === 'working' ? 'OPEN' : 'CLOSED';

              // Extract availability data
              const totalSlots = station.totalSlotNumber.value;
              const availableBikes = station.availableBikeNumber.value;
              const availableBikeStands = station.freeSlotNumber.value;

              // Extract geographic coordinates
              const coordinates = station.location.value.coordinates;

              // Build the object in the format expected by the application
              return {
                status: status,
                name: stationName,
                number: stationNumber,
                address: stationName,
                bikeStands: totalSlots,
                availableBikesStands: availableBikeStands,
                availableBikes: availableBikes,
                position: {
                  lat: coordinates[1],
                  lng: coordinates[0]
                },
                // Additional available information (locality)
                commune: station.address.value.addressLocality,
                // Last update timestamp if available
                lastUpdate: station.availableBikeNumber.metadata.timestamp ?
                  station.availableBikeNumber.metadata.timestamp.value : null
              };
            });
          })
          .catch(error => {
            // Log the error and return an empty array in case of failure
            console.error('Error retrieving Velomagg data:', error);
            return [];
          });
      },
      async flyToNewCity(city) {
        const cityPosition = await this.getCityGeo(city)

        if (!cityPosition) {
          console.error('no city set')
          return
        }

        this.map.flyTo([cityPosition.lat, cityPosition.lon], 13)
      },
      getCityGeo(city, country = 'France') {
        return fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${city},${country}`)
          .then(response => response.json())
          .then(jsonResult => jsonResult[0])
          .catch(err => console.error(err))
      },

      /**
       *
       * @param {{  status: String,
                    name: String,
                    number: Number,
                    address: String,
                    bikeStands: Number,
                    availableBikesStands: Number,
                    availableBikes: Number }} station
       */
      createPopupcontent(station) {
        const stationNumber = station.number
        const stationStatus = (station.status === 'OPEN') ? '✔' : '❌'
        const stationAddress = station.address
        const stationCapacity = station.bikeStands
        const availableBikesStand = (station.availableBikesStands === 0) ? 0 : station.availableBikesStands
        const availableBikesStandPlural = (station.availableBikesStands > 1) ? 's' : ''
        const availableBikes = (station.availableBikes === 0) ? 0 : station.availableBikes
        const availableBikesPlural = (station.availableBikes > 1) ? 's' : ''

        return `<p><b>Station N° </b><span>${stationNumber}</span> - <span>${stationStatus}</span></p>
              <p><b>Adresse : </b><span>${stationAddress}</span></p>
              <p><b>Capacité : </b><span>${stationCapacity}</span></p>
              <p v-bind:class="{ red: station.availableBikes} "><b>Emplacement${availableBikesStandPlural} libre${availableBikesStandPlural} : </b><span>${availableBikesStand}</span></p>
              <p><b>Vélo${availableBikesPlural} disponible${availableBikesPlural} : </b><span>${availableBikes}</span></p>`
      }
    }
  }
</script>
